import {I18n} from 'react-redux-i18n';

import {planPropTypes} from '../../../../utils/propTypes';

import {renderPriceUnit} from '../../utils';

const PlanPricing = ({plan}) => <>
  {plan.price === 0 && <strong className="font-size-xl">{I18n.t('subscriptions.plans.free')}</strong>}
  {plan.price > 0 &&
      <>
        <strong className="font-size-xl">
          {renderPriceUnit(plan.price, plan.currency, 'year')}
        </strong>
      </>
  }
</>;

PlanPricing.propTypes = {
  plan: planPropTypes().isRequired
};

export default PlanPricing;
